class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const desktopWrapper = document.getElementById('FacetsWrapperDesktop');
    if (desktopWrapper) {
      desktopWrapper.innerHTML = parsedHTML.getElementById('FacetsWrapperDesktop').innerHTML;
    }

    const mobileWrapper = document.querySelector('.mobile-facets__main');
    if (mobileWrapper) {
      mobileWrapper.innerHTML = parsedHTML.querySelector('.mobile-facets__main').innerHTML;
    }

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const input = event.target;
    const form = input.closest('form');
    if (!form) return;

    const searchParams = new URLSearchParams(window.location.search);
    const paramName = input.name;
    const paramValue = input.value;

    if (input.type === 'checkbox' || input.type === 'radio') {
      if (input.checked) {
        searchParams.append(paramName, paramValue);
      } else {
        const allValues = searchParams.getAll(paramName);
        searchParams.delete(paramName);
        allValues.forEach(value => {
          if (value !== paramValue) {
            searchParams.append(paramName, value);
          }
        });
      }
    } else if (input.name === 'sort_by') {
      searchParams.set(paramName, paramValue);
    } else if (paramName.includes('price')) {
      // For price ranges, we just set the value. The form will have both gte and lte.
      searchParams.set(paramName, paramValue);
    }

    this.onSubmitForm(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// price code change
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('.range-slider input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
      this.querySelectorAll('.number-slider input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    // this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    // this.setMinAndMaxValues();
    this.adjustToValidValues(event.currentTarget);
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('.range-slider input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    // if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    // if (minInput.value) maxInput.setAttribute('min', minInput.value);
    // if (minInput.value === '') maxInput.setAttribute('min', 0);
    // if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
    let minPrice = inputs[0].value;
    let maxPrice = inputs[1].value;
    if (minPrice > maxPrice) {
      let tempValue = maxPrice;
      maxPrice = minPrice;
      minPrice = tempValue;
      return true
    }
    return false
  }

  adjustToValidValues(input) {
    const isRange = (input.type == "range");
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));
    if (value < min) input.value = min;
    if (value > max) input.value = max;

    // Ruler
    const rangeInputs = this.querySelectorAll('.range-slider input');
    const numberInputs = this.querySelectorAll('.number-slider input');
    const minRangeInput = rangeInputs[0];
    const maxRangeInput = rangeInputs[1];
    const minNumberInput = numberInputs[0];
    const maxNumberInput = numberInputs[1];
    let minPrice = isRange ? rangeInputs[0].value : numberInputs[0].value;
    let maxPrice = isRange ? rangeInputs[1].value : numberInputs[1].value;

    if (Number(minPrice) > Number(maxPrice)) {
      let tempValue = maxPrice;
      maxPrice = minPrice;
      minPrice = tempValue;
      minRangeInput.value= minPrice;
      minNumberInput.value= minPrice;
      maxRangeInput.value = maxPrice;
      maxNumberInput.value = maxPrice;
    }else{
      if(input.classList.contains("rulerinput-min")){
        // document.getElementById("rulermin-value").innerHTML = input.value
        isRange ? minNumberInput.value = minPrice : minRangeInput.value= minPrice;
      }
      if(input.classList.contains("rulerinput-max")) {
        // document.getElementById("rulermax-value").innerHTML = input.value
        isRange ? maxNumberInput.value = maxPrice : maxRangeInput.value= maxPrice;
      }
    }
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
